import { Injectable } from "@angular/core";

import { BaseLoggingService, LogType } from "./logging.model";

@Injectable({
	providedIn: "root",
})
export class LoggingService implements BaseLoggingService {
	log(logType: LogType, message: string | Error, data?: any) {
		// eslint-disable-next-line no-console
		let logFn = console[logType];
		if (!(logFn instanceof Function)) {
			/* use console.log as fallback */
			// eslint-disable-next-line no-console
			logFn = console.log;
		}

		if (data) {
			logFn(message, data);
		} else {
			logFn(message);
		}
	}

	initialize() {
		// no-op
	}

	configureGlobalTags(_: Record<string, string>) {
		// no op
	}
}
